import { render, staticRenderFns } from "./PopQnaDetail.vue?vue&type=template&id=c2e8e6d2"
import script from "./PopQnaDetail.vue?vue&type=script&lang=js"
export * from "./PopQnaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports